import { useState, useEffect } from "react";
import Axios from "axios";
import sha256 from "crypto-js/sha256";
import { toast } from "react-toastify";

import "./alerts.css";
import SetTitle from "../../components/setTitle/SetTitle";
import AddAlertDlg from "../../components/crudSql/addAlertDlg/AddAlertDlg";
import HiddenBlock from "../../components/crudSql/hiddenBlock/HiddenBlock";

import Button from "@mui/material/Button";

// const depositWalletsA = {
//   BSC: { BUSD: "0x61d3193433e672df6ea91a77d80c95c9a32b4233" },
// };

const trackedParametersA = [
  { val: "tvl", ttl: "TVL has dropped (people exit the platform)" },
  {
    val: "balance",
    ttl: "Balance has dropped (someone withdrew tokens)",
  },
  {
    val: "balRwd",
    ttl: "Balance and Rewards do not change (non-working vault)",
  },
  {
    val: "total",
    ttl: "USD Total (Bal+Rwds), has dropped (tokens fall in dollar($) value)",
  },
  {
    val: "tokenUsd",
    ttl: "The dollar($) value of any token included in the LP has fallen",
  },
  {
    val: "balApr",
    ttl: "BalAPR below the specified (investment is not growing fast enough)",
    ttlShort: "Balance APR below",
  },
  {
    val: "totApr",
    ttl: "TotAPR below the specified (investment in $ value is not growing fast enough)",
  },
];

export function AlertData(row) {
  const titlesA = trackedParametersA.filter(
    (obj) => obj.val == row.trackedParameter
  )[0];
  return {
    ttl: titlesA.ttlShort ? titlesA.ttlShort : titlesA.ttl,
    interval:
      row.minutesInterval > 60 * 24
        ? row.minutesInterval / (60 * 24) + " day(s)"
        : row.minutesInterval > 60
        ? row.minutesInterval / 60 + " hour(s)"
        : row.minutesInterval + " minute(s)",
  };
}

export default function Alerts(props) {
  // console.log(props);

  SetTitle("Alerts @ DefiWatch.biz");

  const [alerts, setAlerts] = useState([]);
  const [paymentPeriod, setPaymentPeriod] = useState("Monthly");
  const [paymentPeriodMo, setPaymentPeriodMo] = useState(1);

  const moByPeriod = { Monthly: 1, Annually: 12 };
  useEffect(() => {
    // console.log("moByPeriod", paymentPeriod, moByPeriod[paymentPeriod]);
    setPaymentPeriodMo(moByPeriod[paymentPeriod]);
  }, [paymentPeriod]);

  const getAlerts = () => {
    const apiUrl = "/alerts";
    Axios.get(
      process.env.REACT_APP_CRUD_SRV +
        apiUrl +
        "?auth=" +
        props.userAuthWallet +
        "&cs=" +
        sha256(apiUrl + props.userAuthWallet + process.env.REACT_APP_SECRET)
    ).then((res) => {
      // console.log("alerts", res.data.response.alerts);
      if (res.data?.status == 200) setAlerts(res.data.response.alerts);
    });
  };

  useEffect(() => {
    if (props.userAuthWallet != "") getAlerts();
  }, [props.userAuthWallet]);

  function handleClickDelete(evt) {
    const rowJsonStr = evt.target.getAttribute("data-row");
    const row = JSON.parse(rowJsonStr);

    // if (props.smUserBalanceUsd < pricePerPeriod)
    //   toast.error(
    //     "Not enough balance. Please deposit minimum " +
    //       minDeposit +
    //       " BUSD to DefiWatch.biz wallet " +
    //       depositWalletsA.BSC.BUSD +
    //       " from your Metamask wallet " +
    //       props.userAuthWallet
    //   );
    // else {
    const apiUrl = "/alert/delete";
    // console.log("del", typeof row, {
    //   ...row,
    //   auth: props.userAuthWallet,
    // });
    Axios.post(process.env.REACT_APP_CRUD_SRV + apiUrl, {
      // tracked: row.trackedParameter,
      // threshold: row.threshold,
      // interval: row.minutesInterval,
      ...row,
      auth: props.userAuthWallet,
      cs: sha256(
        apiUrl +
          // row.trackedParameter +
          rowJsonStr +
          props.userAuthWallet +
          process.env.REACT_APP_SECRET
      ).toString(),
    }).then((r) => {
      if (r.data?.status == 200) {
        console.log("Alert " + row.trackedParameter + " has been deleted.");

        // Actions After Plan Upgrate

        getAlerts();
      } else {
        toast.error("Alert deletion error. Please wait a while time and try again.");
      }
    });
    // }
  }

  const [open, setOpen] = useState(false);
  const handleClickOpen = () => {
    setOpen(true);
  };

  // const [openPlans, setOpenPlans] = useState(false);
  // const handleClickOpenPlans = (evt) => {
  //   setOpenPlans(true);
  // };

  // const [openPaidPlans, setOpenPaidPlans] = useState(false);
  // const handleClickOpenPaidPlans = (evt) => {
  //   setPaidWallet(evt.target.getAttribute("data-wallet"));
  //   setOpenPaidPlans(true);
  // };
  // const [paidWallet, setPaidWallet] = useState(false);

  return (
    <div className="pageWallets pageAlerts">
      <div className="paidWalletsHeader">
        <h3>Alerts</h3>

        {props.userAuthWallet && (
          <Button
            variant="outlined"
            className="extraSmall addAdditionalWallet"
            onClick={handleClickOpen}
          >
            Add Alert
          </Button>
        )}
      </div>

      <AddAlertDlg
        getAlerts={getAlerts}
        trackedParametersA={trackedParametersA}
        userAuthWallet={props.userAuthWallet}
        open={open}
        setOpen={setOpen}
      />

      <p className="paidWalletsP">
        DefiWatch alerts are interval based notifications when the investment
        meets your custom criteria.
      </p>
      <p className="paidWalletsP">
        For example, when the APR of any deposited vault is below 5%, it means
        that you are not getting enough money from this vault and it is probably
        better to invest in other vaults. If you add such an alert, then in case
        of such an event, you will receive a message on the Notifications page
        and by email.
      </p>

      {/* {props.userWallets[0]?.wallet} */}
      {alerts
        // .filter((row) => row.wallet != props.userAuthWallet)
        .map((row) => {
          const alertData = AlertData(row);
          
          return (
            <div
              key={row.trackedParameter + row.threshold + row.minutesInterval}
              className={
                "walletRow "
                // + (row.plan ? "walletRowActive" : "walletRowNotActive")
              }
            >
              <span>{alertData.ttl}</span>
              <label
              // className={row.plan ? "walletBadgePaid" : "walletBadgeNotPaid"}
              >
                {/* {row.plan ? row.plan : "Not Active"} */}
                {+row.threshold}%
              </label>
              <label>
                calculated on the basis of the last{" "}
                {alertData.interval}
              </label>
              <Button
                variant="outlined"
                className="extraSmall"
                onClick={handleClickDelete}
                data-row={JSON.stringify(row)}
                // color={row.dateEnd ? "success" : "primary"}
              >
                {/* {row.dateEnd ? "Prolong" : "Activate"} */}
                Delete
              </Button>
            </div>
          );
        })}
    </div>
  );
}
